import React from 'react';

const InfoBox = () => {
	return (
		<></>
	);
};

export default InfoBox;
